import { Colors, Styles } from '../models/shared-charts.model';
export const defaultAxisLabelStyles = {
    fontSize: Styles.FONT_SIZE_12,
    fontFamily: Styles.OPEN_SANS,
    color: Colors.BLACK,
};
export const defaultXAxisConfigs = {
    lineWidth: 1,
    lineColor: Colors.BLACK,
    labelRotation: -45,
    labelsEnabled: true,
};
export const defaultYAxisConfigs = {
    lineWidth: undefined,
    lineColor: Colors.BLACK,
    tickAmount: 6,
    tickColor: '#EDEDED',
    min: 0,
    max: undefined,
    stackLabels: false,
    labelsFormat: '{value}',
    labelsEnabled: true,
};
export const defaultPlotOptionConfigs = {
    maxPointWidth: 32,
    hover: true,
    stacking: 'normal',
    borderWidth: 0,
};
export const defaultData = [];
export const defaultSeriesItems = [
    {
        name: 'Returning',
        data: defaultData.map((item) => item.point2),
        color: '#9eca47',
        hoverColor: '#799E2E',
    },
    {
        name: 'New',
        data: defaultData.map((item) => item.point1),
        color: '#3c8725',
        hoverColor: '#326F20',
    },
];
export const defaultTooltipConfigs = {
    showTooltip: true,
    sharedTooltip: true,
};
